import { post, postpro } from '../index';



export const createBrand = data => {
  return post('/brands', data, true);
};


export const createBrandNew = data => {
  return postpro('/brands', data, false);
};
